/* 
  自定义封装的http请求方法——httpReq 其中对错误进行了统一处理
*/
import axios from "axios";
// 给请求地址前加一个"/api"，在请求头中添加Token

// --- 关键修改：使用环境变量来设置 baseURL ---
// 在本地开发时，如果未设置 REACT_APP_API_BASE_URL，则默认为 '/api'，
// 此时请求会被 setupProxy.js 代理到后端。
// 在 Vercel 部署时，Vercel 会注入 REACT_APP_API_BASE_URL，指向你的后端 URL。
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
// ---------------------------------------------

const instance = axios.create({
  baseURL: API_BASE_URL, // 使用动态的 baseURL
  withCredentials: true,
  timeout: 10000, // 10秒超时
});
// 添加返回拦截器，直接获取返回内容的data
instance.interceptors.response.use((res) => {
  return res.data;
});
// 封装axios方法，并导出httpReq为新的请求工具
export const httpReq = (method, url, data = {}) => {

  return instance({
    method: method,
    url: url,
    data: data,
  });

  // return new Promise((resolve, reject) => {
  //   instance({
  //     method: method,
  //     url: url,
  //     data: data,
  //   }).then(
  //     (data) => {
  //       resolve(data);
  //     },
  //     (err) => {
  //       console.log("请求出错拉！！！", err);
  //     }
  //   );
  // });
};
